<template>
    <a-layout-content class="content">
        <div class="viewTags">
            <tagsViews />
        </div>
        <div class="view">
            <div class="wrapper">
                <a-tabs type="card" :active-key="selectTabKey" v-if="menus && menus.length" @change="onTabChange">
                    <a-tab-pane v-if="!menu.hidden" v-for="menu in menus" :key="menu.path">
                        <span slot="tab" style="display:flex; align-items: center;">
                            <svg-icon :icon-class="menu.meta.icon" class="svg-icon_menu" />
                            <span>{{ menu.meta.name }}</span>
                        </span>
                    </a-tab-pane>
                </a-tabs>
            </div>
            <div class="content-wrapper">
                <keep-alive :include="cachedViews">
                    <router-view :key="key" />
                </keep-alive>
            </div>
        </div>
    </a-layout-content>
</template>
<script>
import tagsViews from '@/components/tagsViews.vue'
export default {
    components: { tagsViews },
    props: ["menus", "selectMenuKey"],
    data() {
        return {
            selectTabKey: '',
            selectSubMenuKey: '',
            selectedKeys: [],
        }
    },
    mounted() {

    },
    computed: {
        cachedViews() {
            // return ['Basic_Info', 'project', 'Site_Investigation', 'Manifest', 'Installation', 'PTesting', 'Acceptance']
            // return ['Basic_Info', ]
            return[]

        },
        key() {
            return this.$route.path
        }
    },

    methods: {
        onTabChange(key) {
            let menu = this.menus.find((item) => {
                return item.path == key
            })
            this.$emit('selectMenu', menu)
        }
    },
    watch: {
        "menus"(val) {
            console.log("sub menus:", val)
        },
        "selectMenuKey": {
            immediate: true,
            handler(val) {
                this.selectedKeys = [val]
                this.selectTabKey = val
            },
        },
    }
}
</script>
<style lang="scss" scoped>
.content {
    display: flex;
    flex-direction: column;
}

.viewTags {
    height: 32px;
}

.view {
    margin: 0px 10px;
    box-sizing: border-box;
    flex: 1;
    padding: 10px;
    background-color: #fff;
    border-radius: 8px;
    overflow-y: auto;
}

.wrapper {
    padding: 0 10px;
}

/deep/ .ant-tabs-bar {
    margin-bottom: 0px !important;
}

/deep/.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    color: #fff;
    background-color: rgb(56, 169, 225);
}

/deep/.ant-tabs-tab-active {
    background-color: #fff !important;
    color: rgb(56, 169, 225) !important;
}

.view::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
}

.view {
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
    overflow-x: hidden;

    display: flex;
    flex-direction: column;
}

.content-wrapper {
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
    flex: 1;
}
</style>